import { render, staticRenderFns } from "./DeliveryAddressChoicePop.vue?vue&type=template&id=2bd4f3a4&"
import script from "./DeliveryAddressChoicePop.vue?vue&type=script&lang=ts&"
export * from "./DeliveryAddressChoicePop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports